export default __webpack_public_path__ + "8901c8a103b570b3f1694786d929e4af.svg";